import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-home",
  "use": "icon-home-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-home\"><defs><style type=\"text/css\"></style></defs><path d=\"M512.093091 146.850909C735.744 315.857455 837.818182 393.495273 884.363636 429.056V884.363636H139.636364V429.568c45.521455-34.629818 146.944-111.522909 372.456727-282.717091M512 139.636364V46.545455c-13.218909 0-26.344727 3.537455-37.282909 11.776-266.24 201.960727-367.104 278.574545-405.271273 307.525818A57.669818 57.669818 0 0 0 46.545455 411.601455V919.272727c0 32.069818 26.996364 58.181818 60.276363 58.181818h810.356364C950.458182 977.454545 977.454545 951.342545 977.454545 919.272727V411.182545c0-17.733818-8.378182-34.490182-22.714181-45.568-37.794909-28.997818-138.24-105.518545-405.410909-307.386181A62.091636 62.091636 0 0 0 512 46.545455v93.090909z\" p-id=\"1729\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/home.svg
// module id = U9Ws
// module chunks = 25